import React, { useRef, useEffect } from 'react';

import useOnClickOutside from 'generics/hooks/on-click-outside';

import './index.scss';

function NavigableList(props, ref) {

  const { items, selectedItemIndex, itemRenderer } = props;

  const navigableListReference = useRef(null);

  useOnClickOutside(navigableListReference, props.onClose || function noop() {});

  useEffect(function onSelectItemIndexChange() {

    if (navigableListReference.current === null) {
      return;
    }

    const listItems = Array.from(navigableListReference.current.children);
    const listItem = listItems[selectedItemIndex];

    if (typeof listItem === 'undefined') {
      return;
    }

    if (props.noScroll === true) {
      return;
    }

    scrollIntoView(listItem.offsetTop);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItemIndex]);

  function scrollIntoView(position) {

    navigableListReference.current.parentNode.scrollTo({
      top: position,
      behavior: 'smooth'
    });

  };

  function renderItem(item, index) {

    const entryAttributes = {
      className: 'item-container',
      onClick(event) {
        return props.onSelect(item, event);
      }
    };

    return <li key={index} {...entryAttributes}>
      {itemRenderer(item, index, selectedItemIndex)}
    </li>;

  }

  function renderItems() {

    const elements = [];
    const itemsLength = items.length;

    for (let index = 0; index < itemsLength; index++) {

      const item = items[index];
      const element = renderItem(item, index);

      elements.push(element);

    }

    const navigableListAttributes = {
      className: 'items-container helptap-list',
      ref: navigableListReference
    };

    return <ul {...navigableListAttributes}>{elements}</ul>;

  }

  function renderMain() {

    const navigableListContainerAttributes = {
      className: 'navigable-list-main hide-scrollbar',
      ref
    };

    return <div {...navigableListContainerAttributes}>
      {renderItems()}
    </div>;

  }

  return renderMain();

}

export default React.forwardRef(NavigableList);